export default __webpack_public_path__ + "static/media/SCENE 6.211a762f.png";